import { render, staticRenderFns } from "./MaintenanceAnnouncement.vue?vue&type=template&id=4a8a57fd&"
import script from "./MaintenanceAnnouncement.vue?vue&type=script&lang=js&"
export * from "./MaintenanceAnnouncement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports